import { Wording } from '@/types';

export const COOKING_WORDING_RS: Wording = {
  components_header_media_content: 'Video snimci o kuvanju',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Recepti',
  components_header_text2: 'Blog',
  components_header_members: 'Članovi',
  hero_text: 'Kuvajte sa strašću, jedite sa radošću',
  hero_button_text: 'Počnite da kuvate već danas',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Svi resursi koji su vam potrebni za učenje, kuvanje i stvaranje bolje hrane',
  components_ressources_span_text: 'Otkrijte bogatu kolekciju video recepata, detaljnih vodiča za kuvanje i stručnih uvida o uparivanju ukusa, prezentaciji hrane i kulinarskoj kreativnosti.',
  components_ressources_card_1_title: 'Inspiracija za kuvanje',
  components_ressources_card_1_text: 'Inspirišite se kreativnim receptima i kulinarskim video zapisima.',
  components_ressources_card_2_title: 'Kulinarsko znanje',
  components_ressources_card_2_text: 'Naučite osnovne tehnike kuvanja, kombinacije ukusa i osnove uparivanja hrane kroz jasne, praktične vodiče.',
  components_ressources_link: 'Gledajte video zapise',
  components_notes_and_google_title_1: 'Kulinarsko obrazovanje',
  components_notes_and_google_title_2: 'Svakodnevno kuvanje',
  components_notes_and_google_title_3: 'Dosledne kulinarske veštine',
  components_review_google_text: 'Recenzije na Google',
  media_content_section_title: 'Video snimci o kuvanju',
  media_content_section_subheader_text: 'Istražite recepte i video zapise sa uputstvima korak po korak.',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Više video snimaka',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Vodiči i članci',
  text2_section_button_more: 'Više članaka',
  components_text1_section_title: 'RECEPTI',
  components_text1_subheader_text: 'Ukusni recepti za svakodnevno kuvanje',
  components_text1_span_text: 'Otkrijte jednostavne recepte za svakodnevne obroke, jasne korake i odlične rezultate.',
  components_text1_card_1_title: 'Započnite dan kako treba',
  components_text1_card_1_text: 'Jednostavni i ukusni recepti za početak dana sa lakoćom i ukusom.',
  components_text1_card_3_title: 'Ideje za ukusan ručak',
  components_text1_card_3_text: 'Ukusni recepti za ručak koji se lako pripremaju i puni su ukusa.',
  components_text1_card_2_title: 'Recepti za utešnu večeru',
  components_text1_card_2_text: 'Topli, zadovoljavajući recepti za večeru, savršeni za opuštene večeri kod kuće.',
  components_text1_link: 'Pogledajte sve recepte',
  components_footer_text: 'Naučite bolje kuvanje, stvorite bolju hranu: Vaša kuhinja, vaše putovanje.',
  components_footer_info: 'Informacije',
  components_footer_registration_number: 'Registarski broj',
  components_footer_legal: 'Pravni',
  components_footer_terms: 'Uslovi i odredbe',
  components_footer_privacy: 'Politika privatnosti',
  button_load_more: 'Učitaj još',
  page_media_1_content_hero_text: 'Откријте једноставне кулинарске видео записе за свачији укус',
  page_text1_hero_text: 'Recepti',
  page_text1_section_title: 'Saveti za kuvanje',
  page_text1_subheader_text: 'Recepti',
  page_text2_hero_text: 'Naš blog',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Članci i vesti',
  enter_email_title: 'Unesite svoju e-mail adresu da biste nastavili',
  enter_email_placeholder_email: 'Email',
  enter_email_button_enter: 'Unesi',
  components_login_success_text: 'Prijava je uspešna!',
  components_card_link_media_content: 'Pusti video',
  components_card_link_text1_content: 'Vidi recept',
  components_card_link_text2_content: 'Vidi članak',
};